import { Controller } from "@hotwired/stimulus";

/**
 * Submits the associated form when a searchable-select dialog closes after a change, so Multiple
 * picks stay open for several ticks and only reload once the reader finishes. Opt-in via markup on
 * a wrapper; does not change searchable-select itself.
 */
export default class extends Controller {
   private dirty = false;
   private dialog: HTMLDialogElement | null = null;

   private readonly onChange = (event: Event): void => {
      if (!(event.target instanceof HTMLSelectElement))
         return;

      if (!this.dialog?.open)
         return;

      this.dirty = true;
      // form-controller listens on document; stop the bubble so auto-submit does not fire per tick.
      event.stopPropagation();
   };

   private readonly onDialogClose = (): void => {
      if (!this.dirty)
         return;

      this.dirty = false;

      const select = this.element.querySelector("select");
      select?.form?.requestSubmit();
   };

   connect(): void {
      this.element.addEventListener("change", this.onChange);
      this.dialog = this.element.querySelector("dialog");
      this.dialog?.addEventListener("close", this.onDialogClose);
   }

   disconnect(): void {
      this.element.removeEventListener("change", this.onChange);
      this.dialog?.removeEventListener("close", this.onDialogClose);
      this.dialog = null;
   }
}
